/* =========================================================
   MOOCHIES — GLOBAL THEME JS
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- HEADER SCROLL SHRINK / GLASS EFFECT ---------- */
  const siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    const toggleHeaderScroll = () => {
      if (window.scrollY > 40) {
        siteHeader.classList.add('scrolled');
      } else {
        siteHeader.classList.remove('scrolled');
      }
    };
    window.addEventListener('scroll', toggleHeaderScroll, { passive: true });
    toggleHeaderScroll();
  }

  /* ---------- EDITORIAL GALLERY — CLICK & DRAG HORIZONTAL SCROLL ---------- */
  const galleryTrack = document.getElementById('editorialGalleryTrack');
  if (galleryTrack) {
    let isDown = false;
    let startX = 0;
    let scrollStart = 0;
    let moved = false;

    function dragStart(e) {
      isDown = true;
      moved = false;
      galleryTrack.classList.add('dragging');
      const pageX = e.touches ? e.touches[0].pageX : e.pageX;
      startX = pageX - galleryTrack.offsetLeft;
      scrollStart = galleryTrack.scrollLeft;
    }
    function dragEnd() {
      isDown = false;
      galleryTrack.classList.remove('dragging');
    }
    function dragMove(e) {
      if (!isDown) return;
      e.preventDefault();
      const pageX = e.touches ? e.touches[0].pageX : e.pageX;
      const x = pageX - galleryTrack.offsetLeft;
      const walk = x - startX;
      if (Math.abs(walk) > 5) moved = true;
      galleryTrack.scrollLeft = scrollStart - walk;
    }
    // prevent image click/drag-ghost from interfering, but still allow normal clicks when not dragged
    galleryTrack.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

    galleryTrack.addEventListener('mousedown', dragStart);
    galleryTrack.addEventListener('mousemove', dragMove);
    galleryTrack.addEventListener('mouseup', dragEnd);
    galleryTrack.addEventListener('mouseleave', dragEnd);
    galleryTrack.addEventListener('touchstart', dragStart, { passive: true });
    galleryTrack.addEventListener('touchmove', dragMove, { passive: false });
    galleryTrack.addEventListener('touchend', dragEnd);

    /* ---- 3D curved-wall rotation, recalculated as the track scrolls ---- */
    const galleryItems = galleryTrack.querySelectorAll('.editorial-gallery-item');
    let rotateTicking = false;

    function updateCardRotation() {
      const trackRect = galleryTrack.getBoundingClientRect();
      const centerX = trackRect.left + trackRect.width / 2;
      const maxDistance = trackRect.width / 2;

      galleryItems.forEach(item => {
        const itemRect = item.getBoundingClientRect();
        const itemCenterX = itemRect.left + itemRect.width / 2;
        let offset = (itemCenterX - centerX) / maxDistance;
        offset = Math.max(-1, Math.min(1, offset));

        const rotateY = offset * -35;
        const translateZ = (1 - Math.abs(offset)) * 40 - Math.abs(offset) * 60;
        const translateX = offset * -20;

        item.style.transform = `rotateY(${rotateY}deg) translateZ(${translateZ}px) translateX(${translateX}px)`;
      });
      rotateTicking = false;
    }

    function requestRotationUpdate() {
      if (!rotateTicking) {
        window.requestAnimationFrame(updateCardRotation);
        rotateTicking = true;
      }
    }

    galleryTrack.addEventListener('scroll', requestRotationUpdate, { passive: true });
    window.addEventListener('resize', requestRotationUpdate);
    updateCardRotation();
  }

  /* ---------- SCROLL REVEAL ---------- */
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => entry.target.classList.add('visible'), i * 60);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    revealEls.forEach(el => observer.observe(el));
  }

  /* ---------- COLLECTION FILTER BUTTONS ---------- */
  document.querySelectorAll('.filter-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      const filterValue = this.dataset.filter;
      document.querySelectorAll('.coll-grid .prod-card').forEach(card => {
        if (!filterValue || filterValue === 'all') {
          card.style.display = '';
        } else {
          card.style.display = card.dataset.tags && card.dataset.tags.includes(filterValue) ? '' : 'none';
        }
      });
    });
  });

  /* ---------- PRODUCT THUMBNAIL SWITCH ---------- */
  document.querySelectorAll('.thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      const newSrc = this.dataset.fullImage;
      const mainImg = document.querySelector('.main-img img');
      if (newSrc && mainImg) mainImg.src = newSrc;
    });
  });

  /* ---------- MOBILE NAV ---------- */
  const burger = document.querySelector('.nav-burger');
  const navLinks = document.querySelector('.nav-links');
  if (burger && navLinks) {
    burger.addEventListener('click', () => navLinks.classList.toggle('mobile-open'));
  }

  /* ---------- CART DRAWER ---------- */
  const cartOverlay = document.querySelector('.cart-drawer-overlay');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');
  const cartClose = document.querySelector('[data-cart-close]');

  function openCart() {
    if (cartOverlay && cartDrawer) {
      cartOverlay.classList.add('open');
      cartDrawer.classList.add('open');
    }
  }
  function closeCart() {
    if (cartOverlay && cartDrawer) {
      cartOverlay.classList.remove('open');
      cartDrawer.classList.remove('open');
    }
  }
  cartTriggers.forEach(t => t.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* ---------- ADD TO CART (AJAX) ---------- */
  document.querySelectorAll('[data-add-to-cart-form]').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(form);
      const submitBtn = form.querySelector('.add-btn');
      const originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.textContent = 'Adding...'; submitBtn.disabled = true; }

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(res => res.json())
        .then(() => {
          if (submitBtn) { submitBtn.textContent = 'Added ✓'; }
          // refresh cart drawer contents
          return fetch('/cart.js').then(r => r.json());
        })
        .then(cart => {
          updateCartCount(cart.item_count);
          openCart();
          setTimeout(() => {
            if (submitBtn) { submitBtn.textContent = originalText; submitBtn.disabled = false; }
          }, 1500);
        })
        .catch(err => {
          console.error('Cart error:', err);
          if (submitBtn) { submitBtn.textContent = originalText; submitBtn.disabled = false; }
        });
    });
  });

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(el => { el.textContent = count; });
  }

  /* =========================================================
     PRODUCT PAGE — COLOUR COMPARE / TOGGLE PANEL
     Reads variant colour-image mapping from a JSON script tag
     with id="ColourVariantData" rendered by the product section.
     ========================================================= */
  /* ---------- HOMEPAGE SLIDE TO SWITCH (standalone drag) ---------- */
  const homeSlideBox = document.getElementById('homeSlideBox');
  if (homeSlideBox) {
    const homeLayerA = document.getElementById('homeLayerA');
    const homeLayerB = document.getElementById('homeLayerB');
    const homeDivider = document.getElementById('homeDividerLine');
    let homeDragging = false;

    function setHomeClip(percent) {
      if (!homeLayerA || !homeLayerB || !homeDivider) return;
      homeLayerA.style.clipPath = `polygon(0 0,${percent}% 0,${percent}% 100%,0 100%)`;
      homeLayerB.style.clipPath = `polygon(${percent}% 0,100% 0,100% 100%,${percent}% 100%)`;
      homeDivider.style.left = percent + '%';
      homeDivider.setAttribute('aria-valuenow', Math.round(percent));
    }
    function homeDragTo(clientX) {
      const rect = homeSlideBox.getBoundingClientRect();
      let percent = ((clientX - rect.left) / rect.width) * 100;
      percent = Math.max(0, Math.min(100, percent));
      setHomeClip(percent);
    }
    function homePointerDown(e) {
      homeDragging = true;
      homeDragTo(e.touches ? e.touches[0].clientX : e.clientX);
    }
    function homePointerMove(e) {
      if (!homeDragging) return;
      homeDragTo(e.touches ? e.touches[0].clientX : e.clientX);
    }
    function homePointerUp() { homeDragging = false; }

    if (homeDivider) {
      homeDivider.addEventListener('mousedown', homePointerDown);
      homeDivider.addEventListener('touchstart', homePointerDown, { passive: true });
      homeDivider.addEventListener('keydown', (e) => {
        const current = parseFloat(homeDivider.style.left) || 50;
        if (e.key === 'ArrowLeft') setHomeClip(Math.max(0, current - 5));
        if (e.key === 'ArrowRight') setHomeClip(Math.min(100, current + 5));
      });
    }
    window.addEventListener('mousemove', homePointerMove);
    window.addEventListener('touchmove', homePointerMove, { passive: true });
    window.addEventListener('mouseup', homePointerUp);
    window.addEventListener('touchend', homePointerUp);

    setHomeClip(50);
  }

  const colourDataEl = document.getElementById('ColourVariantData');
  if (colourDataEl) {
    let colours = [];
    try { colours = JSON.parse(colourDataEl.textContent); } catch (e) { colours = []; }

    if (colours.length > 1) {
      let compareA = 0;
      let compareB = 1;
      let dragPercent = 50;
      let isDragging = false;

      const imageBox = document.getElementById('imageBox');
      const layerA = document.getElementById('layerA');
      const layerB = document.getElementById('layerB');
      const divider = document.getElementById('dividerLine');
      const cartColourLabel = document.getElementById('cartColour');
      const activeColourName = document.getElementById('activeColourName');
      const slideLabelNameA = document.getElementById('slideLabelNameA');
      const slideLabelNameB = document.getElementById('slideLabelNameB');
      const slideLabelA = document.getElementById('slideLabelA');
      const slideLabelB = document.getElementById('slideLabelB');
      const variantIdInput = document.querySelector('[data-variant-id-input]');

      function setLayerImage(layer, colour) {
        if (!layer) return;
        const img = layer.querySelector('img');
        if (img && colour.image) img.src = colour.image;
        layer.dataset.colourId = colour.id;
      }

      function setClip(percent) {
        if (!layerA || !layerB || !divider) return;
        layerA.style.clipPath = `polygon(0 0,${percent}% 0,${percent}% 100%,0 100%)`;
        layerB.style.clipPath = `polygon(${percent}% 0,100% 0,100% 100%,${percent}% 100%)`;
        divider.style.left = percent + '%';
        divider.setAttribute('aria-valuenow', Math.round(percent));
      }

      function updateLabels() {
        if (slideLabelNameA) slideLabelNameA.textContent = colours[compareA].name;
        if (slideLabelNameB) slideLabelNameB.textContent = colours[compareB].name;
      }

      function setActiveLabel(colour) {
        if (cartColourLabel) cartColourLabel.textContent = colour.name;
        if (activeColourName) activeColourName.textContent = colour.name;
        if (variantIdInput) variantIdInput.value = colour.variantId;
      }

      function dragTo(clientX) {
        if (!imageBox) return;
        const rect = imageBox.getBoundingClientRect();
        let percent = ((clientX - rect.left) / rect.width) * 100;
        percent = Math.max(0, Math.min(100, percent));
        dragPercent = percent;
        setClip(percent);
        setActiveLabel(percent < 50 ? colours[compareA] : colours[compareB]);
      }

      function onPointerDown(e) {
        isDragging = true;
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        dragTo(clientX);
      }
      function onPointerMove(e) {
        if (!isDragging) return;
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        dragTo(clientX);
      }
      function onPointerUp() { isDragging = false; }

      if (divider) {
        divider.addEventListener('mousedown', onPointerDown);
        divider.addEventListener('touchstart', onPointerDown, { passive: true });
        divider.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { dragPercent = Math.max(0, dragPercent - 5); setClip(dragPercent); setActiveLabel(dragPercent < 50 ? colours[compareA] : colours[compareB]); }
          if (e.key === 'ArrowRight') { dragPercent = Math.min(100, dragPercent + 5); setClip(dragPercent); setActiveLabel(dragPercent < 50 ? colours[compareA] : colours[compareB]); }
        });
      }
      window.addEventListener('mousemove', onPointerMove);
      window.addEventListener('touchmove', onPointerMove, { passive: true });
      window.addEventListener('mouseup', onPointerUp);
      window.addEventListener('touchend', onPointerUp);

      window.setCompareA = function (idx) {
        compareA = idx;
        setLayerImage(layerA, colours[idx]);
        document.querySelectorAll('.compare-swatch:not(.compare-b)').forEach((el, i) => el.classList.toggle('selected', i === idx));
        updateLabels();
        if (dragPercent < 50) setActiveLabel(colours[idx]);
      };
      window.setCompareB = function (idx) {
        compareB = idx;
        setLayerImage(layerB, colours[idx]);
        document.querySelectorAll('.compare-swatch.compare-b').forEach((el, i) => el.classList.toggle('selected', i === idx));
        updateLabels();
        if (dragPercent >= 50) setActiveLabel(colours[idx]);
      };
      window.selectMainColour = function (el, idx) {
        document.querySelectorAll('#mainSwatches .swatch-item').forEach(s => s.classList.remove('active'));
        el.classList.add('active');
        window.setCompareA(idx);
        dragPercent = 25;
        setClip(dragPercent);
        setActiveLabel(colours[idx]);
      };

      if (slideLabelA) slideLabelA.querySelector('.slide-label-shop').addEventListener('click', () => {
        const url = colours[compareA].url;
        if (url) window.location.href = url;
      });
      if (slideLabelB) slideLabelB.querySelector('.slide-label-shop').addEventListener('click', () => {
        const url = colours[compareB].url;
        if (url) window.location.href = url;
      });

      if (colours[0]) setLayerImage(layerA, colours[0]);
      if (colours[1]) setLayerImage(layerB, colours[1]);
      updateLabels();
      setActiveLabel(colours[0]);
      setClip(50);
    }
  }

});
